import { useTranslation } from 'react-i18next'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'
import { getSortIndicator } from '@/lib/tableHelpers'
import CertificationsTableRow from './CertificationsTableRow'

export default function CertificationsTable({
	certificationsData,
	loading,
	sortColumn,
	sortDirection,
	onSort,
	onDelete,
}) {
	const { t } = useTranslation()
	const rows = Array.isArray(certificationsData) ? certificationsData : []

	if (loading) return <LoadingIndicator />

	if (rows.length === 0) {
		return (
			<NoResultsIndicator
				message={t('trainingCertifications.list.emptyState.title')}
				description={t('trainingCertifications.list.emptyState.description')}
			/>
		)
	}

	return (
		<div className="mt-6 overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
				<thead>
					<tr>
						<th className="py-2 px-4 border-b border-gray-300 text-left w-72">
							<button
								type="button"
								className="flex items-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
								onClick={() => onSort('name')}
							>
								{t('trainingCertifications.list.table.name')}
								{getSortIndicator('name', sortColumn, sortDirection)}
							</button>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<button
								type="button"
								className="flex items-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
								onClick={() => onSort('description')}
							>
								{t('trainingCertifications.list.table.description')}
								{getSortIndicator('description', sortColumn, sortDirection)}
							</button>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-right w-24">
							<span className="font-semibold text-gray-700">{t('trainingCertifications.list.table.actions')}</span>
						</th>
					</tr>
				</thead>
				<tbody>
					{rows.map(certification => (
						<CertificationsTableRow
							key={certification._id}
							certification={certification}
							onDelete={onDelete}
						/>
					))}
				</tbody>
			</table>
		</div>
	)
}
